// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditCredentials_wrapper__3n_Uc","formField":"EditCredentials_formField__1l-12","error":"EditCredentials_error__2WxX6"};